import styled from 'styled-components'

export const GlobalCommandModalLayoutStyled = styled.div`
  position: relative;
`

export const GlobalCommandModalContentAreaStyled = styled.div``

export const GlobalCommandModalCloseAreaStyled = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  padding: ${(props) => props.theme.space.small}
    ${(props) => props.theme.typography.pxToRem(8)} 0;
`
